import React, { useState, useEffect } from "react";
import api from  "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import { useParams } from "react-router-dom";
import { FaUserAlt, FaTruck, FaHouseUser, FaRegMoneyBillAlt } from 'react-icons/fa';
import { GrDocumentUser } from "react-icons/gr";
import { HiOutlineInformationCircle } from "react-icons/hi";
import { MdFormatListNumberedRtl } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ListaMovimentos from "../../Componentes/ListaMovimento";
import "./styles.css";

const Visita = () => {
  const { IDmotorista, IDvisita } = useParams();
  const [DadosMotorista, setDadosMotorista] = useState([]);
  const [NomeMotorista, setNomeMotorista] = useState('-');
  const [VeiculoMotorista, setveiculoMotorista] = useState('-');
  const [listaMov, setlistaMov] = useState({resultMovimentos:[]});
  const navigate = useNavigate();
  const [dadosVisita, setdadosVisita] = useState(
    {
      "Visita": {
        "IDvisita": 0,
        "cliente": {
          "cliente": "-",
          "cpf_cnpj": "-",
          "observacao": "-",
          "endereco": {
            "IDendereco": 0,
            "cep": "-",
            "IDlogradouro": 0,
            "logradouro": "0",
            "numero": "0",
            "complemento": null,
            "bairro": "-",
            "cidade": "-",
            "uf": "-"
          }
        },
        "lote": {
          "IDlote": 0,
          "IDUsuario": 0,
          "IDveiculo": 0,
          "datahora": "2024-08-25T11:12:12.000Z",
          "situacao": 0,
          "nomeUsuario": "0",
          "modeloVeiculo": "0",
          "placaVeiculo": "0",
          "totalVisitas": 0
        },
        "quantidade": "0.00",
        "valor": "0.00",
        "situacao": 0,
        "observacao": null,
        "assinatura": null
      }
    }
  );

  useEffect(function () {
    if (localStorage.getItem("usuarioLogado") === null) {
      navigate("/");
    }
    carregaDadosMotorista(IDmotorista);
  }, []);

  useEffect(function () {
    carregaDadosVisita(IDvisita);
    
    const intervalo = setInterval(() => {
      carregaDadosVisita(IDvisita);
    }, 60000); // 300000 5 minutos
    return () => clearInterval(intervalo);
    
  }, []);

  async function carregaDadosVisita(idvisita){
    let retorno = await buscaDadosVisitas(idvisita);
    setdadosVisita(retorno.data);

    let dadosMovim = await buscaDadosMovimentos(idvisita);
    //console.log(dadosMovim.data.Movimentos);
    setlistaMov(dadosMovim.data.Movimentos);
  }

  async function carregaDadosMotorista(id){
    let retorno = await buscaMotorista(id);
    if(retorno){
      setDadosMotorista(retorno.data);
      setNomeMotorista( String(retorno.data.Usuario.IDusuario).padStart(6, '0') + '  |  ' + retorno.data.Usuario.pessoa.nome + '  |  CPF: ' + formatCPF(retorno.data.Usuario.pessoa.cpf));
      if(retorno.data.Usuario.veiculo){
        setveiculoMotorista(retorno.data.Usuario.veiculo[0].modelo + ' | ANO: ' + retorno.data.Usuario.veiculo[0].ano_modelo + ' | PLACA: ' + retorno.data.Usuario.veiculo[0].placa);
      }
    }
  }

  async function buscaDadosVisitas(id){          
    try {
      const response = await api.get('/visita/'+id);
      return response;

    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async function buscaDadosMovimentos(IDvisita){          
    try {
      const response = await api.get('/movimentos/last/'+IDvisita);
      return response;

    } catch (error) {
      console.log(error);
      return error;
    }
  }

  function formatCPF(cpf) {
    cpf = cpf.replace(/\D/g, '');
  
    if (cpf.length !== 11) {
      return cpf; 
    }
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  async function buscaMotorista(id){          
    try {
      const response = await api.get('/usuario/'+id);
      return response;

    } catch (error) {
      console.log(error);
      return error;
    }
  }

  return (
    <div className="menu-container-visita">

      <MenuLateral/>

      <div id="painel_principal_visita" align="center"> 
        <h5 style={{paddingBottom: '2%'}}>VISITA Nº {String(IDvisita).padStart(5, '0')}</h5>
        <div id="painel_visita" align="left">
          <div className="row">
            <div className="col-sm-10">
              <div>
                <p style={{fontSize:'0.7em', fontWeight: 'bold' }}> <FaUserAlt/> Motorista:</p>
                <p style={{fontWeight: 'Normal', marginTop: '-15px',fontSize:'0.9em'}}>{NomeMotorista}</p>  
              </div>
              <div>
                <p style={{fontSize:'0.7em', fontWeight: 'bold' }}> <FaTruck/> Veivulo:</p>
                <p style={{fontWeight: 'Normal', marginTop: '-15px',fontSize:'0.9em'}}>{VeiculoMotorista}</p>  
              </div>
            </div>
            <div className="col-sm-2" style={{paddingLeft:'3%'}}>
            </div>
          </div>
        </div>

        <div id="div_painel_visita" align="left">
          
          <div className="row">
            <div className="col-sm-3">
              <div>
                <p style={{fontSize:'0.7em', fontWeight: 'bold' }}> <FaUserAlt/> Cliente:</p>
                <p style={{fontWeight: 'Normal', marginTop: '-15px',fontSize:'0.9em'}}>{dadosVisita.Visita.cliente.cliente}</p>  
              </div>
            </div>
            <div className="col-sm-2">
              <div>
                <p style={{fontSize:'0.7em', fontWeight: 'bold' }}> <GrDocumentUser/> CNPJ/CPF:</p>
                <p style={{fontWeight: 'Normal', marginTop: '-15px',fontSize:'0.9em'}}>{dadosVisita.Visita.cliente.cpf_cnpj}</p>  
              </div>
            </div>
            <div className="col-sm-7">
              <div>
                <p style={{fontSize:'0.7em', fontWeight: 'bold' }}> <HiOutlineInformationCircle/> Observações do Cliente:</p>
                <p style={{fontWeight: 'Normal', marginTop: '-15px',fontSize:'0.9em'}}>{dadosVisita.Visita.cliente.observacao}</p>  
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div>
                <p style={{fontSize:'0.7em', fontWeight: 'bold' }}> <FaHouseUser/> Endereço:</p>
                <p style={{fontWeight: 'Normal', marginTop: '-15px',fontSize:'0.9em'}}>
                  {dadosVisita.Visita.cliente.endereco.tipo + ' ' + 
                   dadosVisita.Visita.cliente.endereco.logradouro + ', ' + dadosVisita.Visita.cliente.endereco.numero +
                   ' ' + dadosVisita.Visita.cliente.endereco.complemento + ', ' + 
                   dadosVisita.Visita.cliente.endereco.bairro + ' - ' + 
                   dadosVisita.Visita.cliente.endereco.cidade + '/' + dadosVisita.Visita.cliente.endereco.uf
                  }
                </p>  
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <div>
                <p style={{fontSize:'0.7em', fontWeight: 'bold' }}> <MdFormatListNumberedRtl/> Quantidade:</p>
                <p style={{fontWeight: 'Normal', marginTop: '-15px',fontSize:'0.9em'}}>
                  {dadosVisita.Visita.quantidade}
                </p>  
              </div>
            </div>
            <div className="col-sm-2">
              <div>
                <p style={{fontSize:'0.7em', fontWeight: 'bold' }}> <FaRegMoneyBillAlt/> Valor:</p>
                <p style={{fontWeight: 'Normal', marginTop: '-15px',fontSize:'0.9em'}}>
                  {dadosVisita.Visita.valor}
                </p>  
              </div>
            </div>
            <div className="col-sm-4">
              <div>
                <p style={{fontSize:'0.7em', fontWeight: 'bold' }}> <HiOutlineInformationCircle/> Observações da Visita:</p>
                <p style={{fontWeight: 'Normal', marginTop: '-15px',fontSize:'0.9em'}}>
                  {dadosVisita.Visita.observacao}
                </p>  
              </div>
            </div>
            {/* Verificar se a assinatura existe e exibi-la */}
            {dadosVisita.Visita.assinatura && (
              <div className="col-sm-2">
                <div className="col-sm-12" >
                  <p style={{fontSize: '0.7em', fontWeight: 'bold'}}>Assinatura:</p>
                  <img src={dadosVisita.Visita.assinatura} alt="Assinatura" style={{width: '100%', maxWidth: '200px', maxHeight:'150px', border: '1px solid #ddd', borderRadius: '4px', paddingBottom: '10px'}} />
                  <br/><br/>
                </div>
              </div>
            )}
          </div>
          <div id="painelMovimentos">
           <ListaMovimentos listaMovimento={listaMov} />
          </div>
        </div>

      </div>
    </div>

  );
};

export default Visita;